import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, CadastraFornecedor } from './types';

export const INITIAL_STATE: CadastraFornecedor = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): CadastraFornecedor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CADASTRA_FORNECEDOR_REQUEST: {
				break;
			}
			case Types.CADASTRA_FORNECEDOR_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.CADASTRA_FORNECEDOR_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.CADASTRA_FORNECEDOR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
